<!--
                               o8o                 .
                               `"'               .o8
   .oooo.o  .ooooo.  oooo d8b oooo  oo.ooooo.  .o888oo
  d88(  "8 d88' `"Y8 `888""8P `888   888' `88b   888
  `"Y88b.  888        888      888   888   888   888
  o.  )88b 888   .o8  888      888   888   888   888 .
  8""888P' `Y8bod8P' d888b    o888o  888bod8P'   "888"
                                     888
                                    o888o
 -->

<script>

export default {

  name: 'Burger',

  computed: {
    isPopupOpened () {
      return this.$store.getters.isPopupOpened
    }
  },

  methods: {
    toggleMenu () {
      if (this.$store.getters.isPopupAnimating) return

      if (!this.$store.getters.isPopupOpened) {
        this.$store.dispatch('openPopup', 'menu')
      } else {
        this.$store.dispatch('closePopup')
      }
    }
  }

}

</script>


<!--

  oooo                                                  .
  `888                                                .o8
   888   .oooo.   oooo    ooo  .ooooo.  oooo  oooo  .o888oo
   888  `P  )88b   `88.  .8'  d88' `88b `888  `888    888
   888   .oP"888    `88..8'   888   888  888   888    888
   888  d8(  888     `888'    888   888  888   888    888 .
  o888o `Y888""8o     .8'     `Y8bod8P'  `V88V"V8P'   "888"
                  .o..P'
                  `Y8P'
 -->


<template lang="pug">

button.menu-button(
  type="button"
  :class="{ 'is-crossed': isPopupOpened }"
  @click="toggleMenu")

  .icon
    .icon__line.line-1(ref="line1")
    .icon__line.line-2(ref="line2")

</template>


<!--
               .               oooo
             .o8               `888
   .oooo.o .o888oo oooo    ooo  888   .ooooo.   .oooo.o
  d88(  "8   888    `88.  .8'   888  d88' `88b d88(  "8
  `"Y88b.    888     `88..8'    888  888ooo888 `"Y88b.
  o.  )88b   888 .    `888'     888  888    .o o.  )88b
  8""888P'   "888"     .8'     o888o `Y8bod8P' 8""888P'
                   .o..P'
                   `Y8P'
 -->


<style lang="stylus" scoped>

.menu-button
  position relative
  display flex
  justify-content center
  align-items center
  padding 21px

.icon
  position relative
  display flex
  flex-direction column
  justify-content space-between
  align-items center
  width 23px
  height 15px

  &__line
    display block
    width 23px
    height 5px
    background-color orange
    transition transform .2s

    +above(1024px)

      .menu-button:hover &.line-1
        transform translateY(5px) rotate(0deg)

      .menu-button:hover &.line-2
        transform translateY(-5px) rotate(0deg)

    .menu-button.is-crossed &.line-1
      transform translateY(5px) rotate(45deg)

    .menu-button.is-crossed &.line-2
      transform translateY(-5px) rotate(-45deg)

</style>



// WEBPACK FOOTER //
// burger.vue?d8c44afe